import { required } from "@corporate-tailwind/corp-form"
import { CurrencyPurchaseDto, CurrencyPurchaseSchema } from "../../front-pages/common/fp-order-panel/fp-order-purchase/model/currency-purchase.model"
import { OrderPricingSummaryDto, OrderPricingSummarySchema } from "./order-pricing.model";
import { OrderStatusDto, OrderStatusSchema } from "./order-status.model";
import { OrderApprovalRangeDto, OrderApprovalRangeSchema } from "./order-approval-range.model";

export class OrderDto {
    id: number | null = null;
    code: string | null = null;
    status: OrderStatusDto | null = null;
    dateCreate: Date | null = null;
    currencyPurchaseList: CurrencyPurchaseDto[] | null = null;
    pricingSummary: OrderPricingSummaryDto | null = null;
    // approvalRange: OrderApprovalRangeDto | null = null;
}

export class OrderSchema extends OrderDto {
    static schema = {
        id: { type: Number, builderOption: required },
        code: { type: String, builderOption: required },
        status: { type: OrderStatusSchema, builderOption: required },
        dateCreate: { type: Date, builderOption: required },
        currencyPurchaseList: { type: Array, itemType: CurrencyPurchaseSchema, builderOption: required },
        pricingSummary: { type: OrderPricingSummarySchema, builderOption: required}
        // approvalRange: { type: OrderApprovalRangeSchema, builderOption: required}

    }
}
